module.exports = __webpack_public_path__ + "static/media/new-background.8778da84.png";